/**
 * 主布局 - 登录后的框架（侧边栏 + 内容区）
 * 顶栏显示当前 demo 身份 + 退出
 */

import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { clearToken, getIdentity } from '../api/client'

export interface NavItem {
  label: string
  to: string
}

export function Layout({
  title,
  nav,
  children,
}: {
  title: string
  nav: NavItem[]
  children: ReactNode
}) {
  const nav2 = useNavigate()
  const identity = getIdentity()

  function logout() {
    clearToken()
    nav2('/login')
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside
        style={{
          width: 220,
          background: '#1f2937',
          color: '#fff',
          padding: '16px 0',
          flexShrink: 0,
        }}
      >
        <div style={{ padding: '0 20px 20px', fontWeight: 700, fontSize: 16 }}>{title}</div>
        <nav>
          {nav.map((item) => (
            <a
              key={item.to}
              href={`#${item.to}`}
              onClick={(e) => {
                e.preventDefault()
                nav2(item.to)
              }}
              style={{
                display: 'block',
                padding: '10px 20px',
                color: '#d1d5db',
                textDecoration: 'none',
                fontSize: 14,
              }}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </aside>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <header
          style={{
            height: 48,
            background: '#fff',
            borderBottom: '1px solid #e5e7eb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '0 20px',
            gap: 12,
          }}
        >
          {identity && (
            <span style={{ fontSize: 13, color: '#666' }}>
              {identity.operatorName} · {identity.role}
            </span>
          )}
          <button onClick={logout} style={{ fontSize: 13 }}>
            退出
          </button>
        </header>
        <main style={{ flex: 1, padding: 24, background: '#f9fafb' }}>{children}</main>
      </div>
    </div>
  )
}
